// import { createElement } from 'react'
import type { ReactElement } from 'react'
import ReactDOM from 'react-dom'
// import { Spin } from 'antd'

// 柱状图转换数字为百分比，使柱状图始终占满
export const transPercent = (arr: Array<number>[], len2: number): Array<number>[] => {
    if (arr.length === 0) {
        return []
    }
    const arr2: Array<number>[] = []
    const len = arr[0].length
    for (let i = 0; i < len; i++) {
        const _arr = []
        for (let j = 0; j < len2; j++) {
            _arr.push(arr[j][i])
        }
        arr2.push(_arr)
    }
    const arr3: Array<number>[] = []
    arr2.forEach(item => {
        const len3 = item.length
        const count = item.reduce((prev, num) => prev + num, 0)
        let prevCount = 0
        const _arr: number[] = []
        // 计算除最后一个数前面的
        for (let i = 0; i < len3 - 1; i++) {
            const num = count === 0 ? 0 : Math.round(item[i] / count * 100)
            prevCount += num
            _arr.push(num)
        }
        // 前面的数就超过100，倒数第二个数减去超出数
        if (prevCount > 100) {
            _arr[_arr.length - 1] -= prevCount - 100
            // 最后一个数
            _arr.push(0)
        } else {
            // 计算最后一个数
            const last = item[item.length - 1]
            _arr.push(100 - (prevCount === 0 ? (last ? 0 : 100) : prevCount))
        }
        arr3.push(_arr)
    })
    return arr3
}

export function dateTime(): string {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    const time = year.toString() + month + day + hours + minutes + seconds
    // 拼接
    return time
}

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export function debounce (handle: (...args: any) => void, wait?: number | boolean, immediate?: boolean): any {
    if (typeof handle !== 'function') throw new Error('handle muse be function')
    if (typeof wait === 'undefined') wait = 300
    if (typeof wait === 'boolean') {
        immediate = wait
        wait = 1000
    }
    if (typeof immediate !== 'boolean') immediate = false
    let timer: any = null
    return function proxy (this: any, ...args: any[]) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const me = this,
            init = immediate && !timer
        clearTimeout(timer)
        timer = setTimeout(() => {
            timer = null
            !immediate ? handle.call(me, ...args) : null
        }, wait as number)
        init ? handle.call(me, ...args) : null
    }
}

export function getUuid (len: number, radix?: number): string {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    const uuid = []
    let i
    radix = radix || chars.length

    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
        let r

        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'

        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
            }
        }
    }

    return uuid.join('')
}

export function ltrim(str: string): string {
    if(str === '' || str === undefined){
        return ''
    }
    let n = 0
    for (let i = 0, length = str.length; i < length; i++) {
        const c = str.charAt(i)
        if(c !== ' '){ //如果为空，就将索引继续添加。 里面有一个空格。
            break
        }
        n++
    }
    return str.substring(n)
}

export function rtrim(str: string): string {
    if(str === '' || str === undefined){
        return ''
    }
    let n = str.length
    for (let i = str.length - 1; i >= 0; i--) {
        const c = str.charAt(i)
        if(c !== ' '){ //如果为空，就将索引继续添加。
            break
        }
        n--
    }
    return str.substring(0,n)
}

export function downloadFile (res: {
    data: any
    type: string
    suffix: string
}, fileName: string): void {
    const blob = new Blob([res.data], { type: res.type })
    const href = window.URL.createObjectURL(blob)
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = href
    document.body.appendChild(elink)
    elink.click()
    document.body.removeChild(elink)
    window.URL.revokeObjectURL(href)
}

// 原生js判断是否包含class
export function hasClass(node: HTMLElement, className: string): boolean {
    const names = node.className.split(/\s+/) //这个正则表达式是因为class可以有多个,判断是否包含
    for(let i = 0, len = names.length; i < len; i++){
        if (names[i] == className) return true
    }
    return false
}

function CPos(this: any, x: number, y: number): void {
    this.x = x
    this.y = y
}
// 获取元素在页面中的位置
export function GetObjPos(ATarget: HTMLElement, parentClassName: string): any {
    const pos = new (CPos as any)(ATarget.offsetLeft, ATarget.offsetTop)
    let target = ATarget.offsetParent as HTMLElement
    while (target) {
        if (parentClassName && hasClass(target, parentClassName)) {
            pos.x += target.offsetLeft
            pos.y += target.offsetTop
            break
        } else {
            pos.x += target.offsetLeft
            pos.y += target.offsetTop
            target = target.offsetParent as HTMLElement
        }
    }
    return pos
}

// function LoadingElement (): ReactElement {
//     return createElement('Spin', {
//         size: 'large',
//         style: {
//             width: '100px'
//         }
//     })
// }
// 显示loading
// 调用: showLoading(<Spin size='large' />)
export function showLoading (element: ReactElement): void {
    const dom = document.createElement('div')
    dom.setAttribute('id', 'loading')
    document.body.appendChild(dom)
    document.body.classList.add('overflow_hidden')
    // const element: ReactElement = <Spin size='large'></Spin>
    // ReactDOM.render(LoadingElement(), dom)
    ReactDOM.render(element, dom)
}

// 隐藏loading
export function hideLoading (): void {
    const loading = document.getElementById('loading')
    if (loading) {
        document.body.removeChild(loading)
        document.body.classList.remove('overflow_hidden')
    }
}

export function compile (code: string): string {
    let c = String.fromCharCode(code.charCodeAt(0) + code.length)
    for(let i = 1;i < code.length;i++){  
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
    }  
    return escape(c)
}
export function uncompile (code: string): string {  
    code = unescape(code)  
    let c = String.fromCharCode(code.charCodeAt(0) - code.length)  
    for(let i = 1;i < code.length;i++){  
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))  
    }  
    return c  
}

export function autoClick (url: string): void {
    const elink = document.createElement('a')
    elink.style.display = 'none'
    elink.target = '_blank'
    elink.href = url
    document.body.appendChild(elink)
    const event = document.createEvent('MouseEvents')
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    elink.dispatchEvent(event)
    document.body.removeChild(elink)
}

export const splitStream = (splitOn: string): TransformStream => {
    let buffer = ''
    return new TransformStream({
        transform(chunk, controller) {
            buffer += chunk
            const parts = buffer.split(splitOn)
            parts.slice(0, -1).forEach((part) => controller.enqueue(part))
            buffer = parts[parts.length - 1]
        },
        flush(controller) {
            if (buffer) controller.enqueue(buffer)
        }
    })
}

export const copyToClipboard = async (text: string): Promise<boolean> => {
    let result = false
    if (!navigator.clipboard) {
        const textArea = document.createElement('textarea')
        textArea.value = text

        // Avoid scrolling to bottom
        textArea.style.top = '0'
        textArea.style.left = '0'
        textArea.style.position = 'fixed'

        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
            const successful = document.execCommand('copy')
            const msg = successful ? 'successful' : 'unsuccessful'
            console.log('Fallback: Copying text command was ' + msg)
            result = true
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err)
        }

        document.body.removeChild(textArea)
        return result
    }

    result = await navigator.clipboard
        .writeText(text)
        .then(() => {
            console.log('Async: Copying to clipboard was successful!')
            return true
        })
        .catch((error) => {
            console.error('Async: Could not copy text: ', error)
            return false
        })

    return result
}

export function wrapText(text: string, maxLength: number, splitStr?: string): string {
    let result = ''
    let currentLine = ''

    for (let i = 0, len = text.length; i < len; i++) {
        // 添加当前字符到当前行
        currentLine += text[i]

        // 如果当前行长度达到了maxLength或者达到了字符串的末尾
        // 并且当前行不是空的（避免在字符串开头就添加换行符）
        if (currentLine.length === maxLength && i < len - 1) {
            // 将当前行添加到结果字符串，并加上换行符
            result += currentLine + (splitStr ?? '<br />')
            // 重置当前行为空，以便开始新的一行
            currentLine = ''
        } else if (i === len - 1 && currentLine.length > 0) {
            result += currentLine
        }
    }

    // 移除结果字符串末尾可能多余的换行符（如果原字符串长度正好是maxLength的倍数）
    if (result.endsWith('\n')) {
        result = result.slice(0, -1)
    }

    return result
}